export const permitURL = [
  "/auth/login",
  "/auth/sms",
  "/auth/sms/report",
  "/auth/upLoad",
  "/server/staff/forget/pwd",
  "/server/supplier/register",
  "/server/company/register"
]